import React from 'react';

export function PromotionPageShell({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex justify-center items-center bg-slate50 p-8">
      <div className="bg-lightGray rounded-lg shadow-md p-4 w-[750px] relative border font-semibold">
        <h1 className="text-left">{title}</h1>
        <p className="mt-1 text-xs text-gray font-normal">{description}</p>
        {children}
      </div>
    </div>
  );
}
